import _ from 'lodash';
import buildSearchWordsExpression from '../buildSearchWordsExpression.js';

export default {
  getPathExpression: (path, value, isNegated) => {
    const ancestors = _.take(path, path.length - 1);
    const last = _.last(path);
    const fieldNames = last.split(',').map(_.trim);
    const completeFieldNames = _.map(fieldNames, fieldName => [...ancestors, fieldName].join('.'));

    return buildSearchWordsExpression(
      _.chain(value).replace(/\s+/g, ' ').split(' ').map(_.trim).compact().value(),
      completeFieldNames,
      isNegated
    );
  }
};
